import axios from './axios';

const getSingleton = singleton => axios.get(`singletons/get/${singleton}?populate=1`);
const getCollection = collection => axios.get(`collections/get/${collection}`);

export default {
  getSingleton: getSingleton,
  getCollection: getCollection
}